import { UserStatusEnums } from 'src/modules/userAccess/types';
import { EnumType } from 'src/core/types/enum';

// resolveKey is a helper function that resolves a key from a nested object
export function resolveKey<T>(path: string, obj): T | any {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self) as T | any;
}

/**
 * Returns the color status class based on the given status.
 * @param {string} status - The status of the dataset.
 * @returns {string} - The color status class.
 */
export function returnColorStatus(status: UserStatusEnums) {
  if (status === UserStatusEnums.ACTIVE) return 'bg-green-200 text-green-800';
  if (status === UserStatusEnums.INACTIVE) return 'bg-red-200 text-red-800';
  if (status === UserStatusEnums.DEACTIVATED)
    return 'bg-slate-300 text-slate-500';
}

/**
 * Maps a user/supplier status to a MeridiaTag colour state.
 * Shared by the supplier tables (and mirrors the customer surfaces).
 * @param {string} status - The uppercased status value.
 * @returns {string} - The MeridiaTag `state` colour.
 */
export function returnTagState(status: string) {
  if (status === UserStatusEnums.ACTIVE) return 'emerald';
  if (status === UserStatusEnums.INACTIVE) return 'pink';
  if (status === UserStatusEnums.DEACTIVATED) return 'slate';
  return 'slate';
}

export function getRemainingDays(date: Date) {
  const today = new Date();
  const dateAux = new Date(date);
  const remaining = dateAux.getTime() - today.getTime();
  const formattedRemainingDays = Math.ceil(
    remaining / (1000 * 60 * 60 * 24)
  ).toString();
  return formattedRemainingDays;
}

/**
 * Extracts values from commodities arrays and combines them into a single array.
 * @param customer - The customer object containing commodities arrays
 * @returns Combined array of commodity values
 */
export function getCommoditiesValues(customer: {
  commodities?: EnumType[];
}): string[] {
  return customer.commodities?.map((c) => c.value) || [];
}
